import React from "react";
import { Translation } from "react-i18next";
import Sidebar from "../sharedNew/sidebar/Sidebar";
import SidebarCollapse from "../sharedNew/sidebar/SidebarCollapse";
import SidebarList from "../sharedNew/sidebar/SidebarList";
import Landing from "./Landing";
import * as CONSTANTS from "../../utilities/Constants";
import {
  ISidebarDetail,
  SidebarDetail,
} from "../../models/shared/SidebarDetail";
import sampleListStoreNew from "../../flux/stores/sample/ListStoreNew";
import sampleListStore from "../../flux/stores/sample/ListStore";
import {
  defaultSampleData,
  ISampleViewData,
} from "../../models/sample/SampleViewData";
import loadingActions from "../../flux/actions/LoadingActions";
import sampleActions from "../../flux/actions/SampleActions";
import { v4 as uuidv4 } from "uuid";
import sampleByIdStore from "../../flux/stores/sample/ByIdStore";
import checkInstrumentInUse from "../../flux/stores/sample/CheckInstrumentInUse";
import moment, { utc } from "moment";
import { SampleFormData } from "../../models/Sample/SampleFormData";
import History from "../../utilities/History";
import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";
import { Status } from "../../models/sample/Status";
import triggerNotifications from "../../utilities/TriggerNotifications";
import SampleNewSidebarCreate from "../shared/SampleNewSidebarCreate";
import SampleFilter from "../shared/SampleFilter";
import { IProductViewData } from "../../models/product/ProductViewData";
import gradeActions from "../../flux/actions/GradeActions";
import gradeListStore from "../../flux/stores/grade/ListStore";
import productActions from "../../flux/actions/ProductActions";
import productListStore from "../../flux/stores/product/ListStore";
import sourceActions from "../../flux/actions/SourceActions";
import sourceListStore from "../../flux/stores/source/ListStore";
import { ISourceViewData } from "../../models/source/SourceViewData";
import { IGradeViewData } from "../../models/grade/GradeViewData";
import sampleStatusStore from "../../flux/stores/sample/SampleStatusStore";
import sampleFormStore from "../../flux/stores/sample/FormStore";
import NoDataOnboarding from "../shared/NoDataOnboarding";
import scannerActions from "../../flux/actions/ScannerAction";
import scannerByIdStore from "../../flux/stores/scanner/ByIdStore";
import i18next from "i18next";
import { IScannerViewData, defaultScannerViewData } from "../../models/scanner/ScannerViewData";
import { Icon, Spinner } from "@abb/abb-common-ux-react";
interface ISidebarprops {
  collapseSidebar: boolean;
  searchValue: string;
  onCreateClick: () => void;
  viewAll: () => void;
  onDelete: (e: string) => any;
  inputSampleName: string;

  cloneClick?: (e: any) => void;

  /*======================*/
  setName?: (val: string) => void;
  inputName?: any;
  onActivate?: () => void;
  isShowPopup?: boolean;
  onSave?: (e: any, val: boolean) => void;
  onDeactivate?: () => void;
  module?: string;
  setCode?: (val: string) => void;
  inputCode?: any;
  isShowCodeInput?: boolean;
  nameError?: boolean;
  codeError?: boolean;
  isButtonDisabled?: boolean;
  location: any;
  /*======================*/
}

interface IState {
  activeId: string;
  activeItem: ISampleViewData;
  scannerData: IScannerViewData;
  listData: ISidebarDetail[];
  isFullSidebarVisible: boolean;
  inputSampleName: string;
  showPopup: boolean;
  showGradePopup: boolean;
  isClonedCreated: boolean;
  showProductPopup: boolean;
  inputCode: string;
  showCodeInput: boolean;
  nameError: boolean;
  buttonDisabled: boolean;
  searchValue: string;
  showFilter: boolean;
  selectFromDate: string | null;
  selectToDate: string | null;
  selectedDateRange: any[];
  gradeList: any[];
  selectedGrade: any[];
  measurementStatusList: any[];
  selectedMeasurementStatus: any[];
  productDataList: any[];
  productList: any[];
  selectedProduct: any[];
  sourceList: any[];
  selectedSource: any[];
  hasFiltersChanged: boolean;
  collapseSidebar: boolean;
  onCreateClick: () => void;
  viewAll: () => void;
  toastMsg: string;
  isToast: boolean;
  filterOrder:'Desc'|'Asc';
  isLoading: boolean;
  sortOrder: number;
  priority: any;
  isSorted: boolean;
  originalListData: any;
}

export default class Index extends React.Component<ISidebarprops, IState> {
  private _listData: ISidebarDetail[] = [];
  private _activeId: any;
  private _activeItem: any;
  private _listRef: any;
  private _hasMore: boolean = true;
  private _page: number = 1;
  private _pageToScroll = 0;
  private _datetimeFormat = "YYYY-MM-DD HH:mm:ss";
  private _checkInstrument: any;
  private _pageSize: number = 30; // Default page size is 30
  private _childRef: any;

  private _isValid: boolean = true;
  private _message: string[];
  private _ALL = "ALL";
  private _defaultDrpOption = [{ value: this._ALL, label: this._ALL }];
  private _reloadFirst = true;
  private _id = "";

  private _mount = false;

  private daterange = CONSTANTS.DATE_RANGES;
  private _gradeList: any[] = [];
  private _productList: any[] = [];
  private _sourceList: any[] = [];

  private sampleDateTime : any;
  private filterWrapperRef: any;

  constructor(props: any) {
    super(props);
    const sampleName = this.props.location &&  this.props.location.state && this.props.location.state.sampleName  ? this.props.location.state.sampleName : '';

    this.sampleDateTime = this.props.location &&  this.props.location.state && this.props.location.state.sampleDate  ? this.props.location.state.sampleDate : null;

    this._childRef = React.createRef();
    this.filterWrapperRef = React.createRef();
    this.state = {
      collapseSidebar: false,
      activeId: "",
      searchValue:  sampleName ||"",
      filterOrder:sampleName ? 'Asc' : 'Desc',
      activeItem: defaultSampleData,
      scannerData: defaultScannerViewData,
      listData: [],
      isFullSidebarVisible: true,
      inputSampleName: "",
      isClonedCreated: false,
      showPopup: false,
      showGradePopup: false,
      showProductPopup: false,
      inputCode: "",
      showCodeInput: false,
      nameError: false,
      buttonDisabled: false,
      showFilter: false,
      selectedDateRange: [],
      selectFromDate: null,
      selectToDate:  null,
      gradeList: [],
      selectedGrade: this._defaultDrpOption,
      measurementStatusList: [],
      selectedMeasurementStatus: this._defaultDrpOption,
      productDataList: [],
      productList: [],
      selectedProduct: this._defaultDrpOption,
      sourceList: [],
      selectedSource: this._defaultDrpOption,
      hasFiltersChanged: false,
      onCreateClick: this.onCreateClick,
      viewAll: this.viewAll,

      toastMsg: "",
      isToast: false,
      isLoading: false,
      sortOrder: 0,
      priority: ["Pending", "Measuring", "Paused", "Stopped", "Measured", "Approved", "Rejected"],
      isSorted: false,
      originalListData: [],
    };
  }

  componentDidMount() {
    History.replace({ state: {} })
    if (window.screen.height > 800) {
      this._pageSize = 30;
    }
    this.sidebarAPIs();
    this.actionCall();
    this.storeCall();
  }

  private sidebarAPIs() {
    gradeActions
      .getAll(
        true,
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState(
          {
            gradeList: this._gradeList,
          },
          () => this.forceUpdate()
        );
      });
    gradeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      state.gradeDataList.result.forEach((grade: IGradeViewData) => {
        const gradeList = {
          label: grade.name,
          value: grade.id,
        };
        this._gradeList.push(gradeList);
      });
    });

    productActions
      .getAll(
        true,
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState(
          {
            productList: this._productList,
          },
          () => this.forceUpdate()
        );
      });
    productListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {

      state.productDataList.result.forEach((product: IProductViewData) => {
        const data = {
          label: product.name,
          value: product.id,
        };
        this._productList.push(data);
      });
      this.setState({
        productDataList: state.productDataList.result,
      });
    });

    sourceActions
      .getAll(
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState(
          {
            sourceList: this._sourceList,
          },
          () => this.forceUpdate()
        );
      });
    sourceListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {

      state.sourceDataList.result.forEach((source: ISourceViewData) => {
        const data = {
          label: source.name,
          value: source.id,
        };

        this._sourceList.push(data);
      });
    });

    sampleActions
      .getSampleStatus()
      .then(() => {
        loadingActions.setLoading(false);
      })
      .catch(() => {
        loadingActions.setLoading(false);
      });
    sampleStatusStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      const dropdownList: any[] = [];
      state.data.forEach((source: ISourceViewData) => {
        const dropdown = {
          label: source.name,
          value: source.id,
        };

        dropdownList.push(dropdown);
      });

      this.setState({
        measurementStatusList: [...dropdownList],
      });
    });
    window.addEventListener('resize', this.updateSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSize);
  }

  public updateSize = () => {
    if(window.innerHeight > 1300){
      loadingActions.setLoading(true);
      this._page = this._page + 3;
  
      const payload: any = {
        isAll: true,
        page: this.state.sortOrder === 0 ? this._page : null,
        pageSize: this.state.sortOrder === 0 ? this._pageSize :  null,
        sort: "SampleDate",
        order: "Desc",
        OrderPrecedence: this.state.sortOrder,
        filter: this.state.searchValue ? `Name:${this.state.searchValue}` : "",
        startDateTime: this.state.selectFromDate
          ? moment(new Date(this.state.selectFromDate).toUTCString()).utc().format()
          : moment(new Date(Date.now() + -10 * 365 * 24 * 3600 * 1000).toUTCString()).utc().format(),
        endDateTime: this.state.selectToDate
          ? moment(new Date(this.state.selectToDate).toUTCString()).utc().format()
          : moment(new Date(Date.now() + 60 * 1000).toUTCString()).utc().format(),
        gradeIds: null,
        productIds: null,
        measurementStatusIds: null,
        sourceIds: null,
      };
      const requestId = uuidv4();
      sampleActions
        .postAll(payload, requestId)
        .then(() => {
          loadingActions.setLoading(false);
          const data = [...this.state.listData, ...this._listData];
          this.setState({ listData: data });
        })
        .catch(() => loadingActions.setLoading(false));
    }
  }

  private actionCall() {
    this.setState({isLoading: true});
    let startDateTimeReq = moment(new Date(Date.now() + -10 * 365 * 24 * 3600 * 1000).toUTCString()).utc().format();
    let endDateTimeReq = moment(new Date(Date.now() + 60 * 60 * 1000).toUTCString()).utc().format();
    if(this.state.filterOrder === 'Asc' && this.sampleDateTime){
      startDateTimeReq= moment(this.sampleDateTime).utc().subtract(1,'minutes').format();
      endDateTimeReq= moment(this.sampleDateTime).utc().add(1,'minutes').format();
    } else if(this.state.selectFromDate && this.state.selectToDate){
      startDateTimeReq = moment(new Date(this.state.selectFromDate).toUTCString()).utc().format();
      endDateTimeReq = moment(new Date(this.state.selectToDate).toUTCString()).utc().format();
    }
    const payload: any = {
      isAll: true,
      page: this.state.sortOrder === 0 ? this._page : null,
      pageSize: this.state.filterOrder === 'Desc' || this.state.sortOrder === 0 ? this._pageSize : 1,
      sort: this.state.filterOrder === 'Desc' ? "SampleDate" : "Name",
      OrderPrecedence: this.state.sortOrder,
      order: this.state.filterOrder,
      filter: this.state.searchValue ? `Name:${this.state.searchValue}` : "",
      startDateTime: startDateTimeReq,
      endDateTime: endDateTimeReq, // added +1 hour to get latest samples
      gradeIds: null,
      productIds: null,
      measurementStatusIds: null,
      sourceIds: null,
    };

    const requestId = uuidv4();
    sampleActions.postAll(payload, requestId).then(() => {
      loadingActions.setLoading(false);
      this.setState({isLoading: false});
      this.reset();
      this.setState({ listData: this._listData }, () => {
        const firstItem = this.state.listData[0];
        if (this.state.listData.length > 0) {
          this.triggerGetById(firstItem.id);
        }
      });
    }).catch((error) => {
      console.error(error);
      this.setState({isLoading: false});
    });
  }

  private getInputNameForClone(existingName: string): string {

    const newNameOnly = existingName.match(/\d+/g);
    const newName = existingName.replace(/(\d+)+/g,  function(_match, number):any{
      let newNameOnlyLength = number.length;
      if (number === newNameOnly[newNameOnly.length - 1]){
        // const newNameOnlyLength = newNameOnly[newNameOnly.length - 1].length;
        let incNumber = parseInt(number) + 1;
        let incNumberSameLength = incNumber.toString().padStart(newNameOnlyLength, "0")
        return incNumberSameLength;
      }
      else{
        // const newNameOnlyLength = newNameOnly[newNameOnly.length - 1].length;
        let incNumber = parseInt(number);
        let incNumberSameLength = incNumber.toString().padStart(newNameOnlyLength, "0")
        return incNumberSameLength;
      }
    });
    return newName;
  }

  private triggerGetById(id: string) {
    sampleActions.getById(id).then(() => {
      const instrumentIdArray: string[] = this._activeItem.measured.map(
        (item: any) => {
          return item?.instrument?.id;
        }
      ); // return an array of instrument ids
      sampleActions.checkinstrumentinuse(instrumentIdArray).then(() => {
        console.log(this._checkInstrument);
        // LOOKUP:  With the help of map() and find()
        this._activeItem.measured = this._activeItem.measured.map(
          (item: any) => {
            let temp = this._checkInstrument.find(
              (element: any) => element.id === item.instrument.id
            );
            if (item?.instrument?.id === temp?.id) {
              item.checkInstrumentInUse = temp;
            }
            return item;
          }
        );
        this.setState(
          {
            inputSampleName: this.getInputNameForClone(this._activeItem.name),
            activeItem: this._activeItem,
            activeId: this._activeId,
          },
          () => {
            const receivedData = this.state.activeItem;
            const editData = new SampleFormData(
              true,
              uuidv4(),
              receivedData.id,
              receivedData.name,
              receivedData.description,
              receivedData.product?.id,
              receivedData.source?.id,
              receivedData.orderId,
              receivedData.setId,
              receivedData.sampleDate,
              receivedData.source?.name,
              receivedData.product?.name,
              "",
              receivedData?.grade?.id,
              receivedData.testPlan?.id,
            );
            editData.gradeId = receivedData?.grade?.id;
            editData.gradeName = receivedData?.grade?.name;
            editData.testplanId = receivedData.testPlan?.id;
            editData.testplanName = receivedData.testPlan?.name;

            const data: IActionHeaderEditData = {
              moduleName: CONSTANTS.MODULE_SAMPLE_NEW,
              editData,
              deleteTitle: receivedData.name,
              deleteId: receivedData.id,
              exportId: receivedData.id,
              deleteRequestId: uuidv4(),
              deleteMessage: receivedData.name,
              isEnableReport:
                receivedData.status.name === Status.NOTMEASURED ? false : true,
            };
            actionHeaderActions.edit(data).then();
          }
        );
      });
    });
  }

  private storeCall() {
    checkInstrumentInUse.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._checkInstrument = state.instrumentData.data;
    });

    // ACTION CALL -> sampleActions.postAll()
    sampleListStoreNew.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._listData = [];
      if (
        state.sampleDataList.currentPage === state.sampleDataList.totalPages ||
        state.sampleDataList.totalRecords == 0 || this.state.sortOrder !== 0
      ) {
        this._hasMore = false;
      } else {
        this._hasMore = true;
      }
      const data = state.sampleDataList.result as ISampleViewData[];

      data.forEach((element) => {
        if (!this._listData.find(item => item.id === element.id)) {
          this._listData.push(
            new SidebarDetail(element.id, element.name, element.status.name)
          );
        }
      });
    });

    // ACTION CALL -> sampleActions.getById()
    sampleByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._activeItem = state.sampleData;
      this._activeId = state.sampleData.id;
    });

    scannerByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {

      this.setState({
        scannerData: state.data,
      });
    });

    sampleListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._listData = [];
      if (
        state.sampleDataList.currentPage === state.sampleDataList.totalPages ||
        state.sampleDataList.totalRecords == 0 || this.state.sortOrder !== 0
      ) {
        this._hasMore = false;
      } else {
        this._hasMore = true;
      }
      const data = state.sampleDataList.result as ISampleViewData[];
      data.forEach((element) => {
        this._listData.push(
          new SidebarDetail(element.id, element.name, element.status.name)
        );
      });
    });

    sampleFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._message = state.message;
    });
  }

  onCollapseSidebar = () => {
    this.setState({
      collapseSidebar: !this.state.collapseSidebar,
    });
  };

  onSearch = (value: any) => {
    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);

      const payload: any = {
        isAll: true,
        page: this.state.sortOrder === 0 ? 1 : null,
        pageSize: this.state.sortOrder === 0 ? this._pageSize : null,
        sort: "SampleDate",
        order: "Desc",
        OrderPrecedence: this.state.sortOrder,
        filter: value ? `Name:${value}` : '',
        startDateTime: this.state.selectFromDate
          ? moment(new Date(this.state.selectFromDate).toUTCString()).utc().format()
          : moment(new Date(Date.now() + -10 * 365 * 24 * 3600 * 1000).toUTCString()).utc().format(),
        endDateTime: this.state.selectToDate
          ? moment(new Date(this.state.selectToDate).toUTCString()).utc().format()
          : moment(new Date(Date.now() + 60 * 1000).toUTCString()).utc().format(),
        gradeIds: null,
        productIds: null,
        measurementStatusIds: null,
        sourceIds: null,
      };
      const requestId = uuidv4();
      sampleActions.postAll(payload, requestId).then(() => {
        loadingActions.setLoading(false);
        this.setState({ listData: this._listData, searchValue: value }, () => {
          const firstItem = this.state.listData[0];
          if (this.state.listData.length > 0) {
            this.triggerGetById(firstItem.id);
          }
        });
      });
    } else {
      this.setState({ searchValue: value });
    }
  };

  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  };

  public fetchMore = () => {
    if(this.state.sortOrder === 0){
      loadingActions.setLoading(true);
      this._page = this._page + 1;
  
      const payload: any = {
        isAll: true,
        page: this.state.sortOrder === 0 ? this._page : null,
        pageSize: this.state.sortOrder === 0 ? this._pageSize : null,
        sort: "SampleDate",
        order: "Desc",
        OrderPrecedence: this.state.sortOrder,
        filter: this.state.searchValue ? `Name:${this.state.searchValue}` : "",
        startDateTime: this.state.selectFromDate
          ? moment(new Date(this.state.selectFromDate).toUTCString()).utc().format()
          : moment(new Date(Date.now() + -10 * 365 * 24 * 3600 * 1000).toUTCString()).utc().format(),
        endDateTime: this.state.selectToDate
          ? moment(new Date(this.state.selectToDate).toUTCString()).utc().format()
          : moment(new Date(Date.now() + 60 * 1000).toUTCString()).utc().format(),
        gradeIds: null,
        productIds: null,
        measurementStatusIds: null,
        sourceIds: null,
      };
      const requestId = uuidv4();
      sampleActions
        .postAll(payload, requestId)
        .then(() => {
          loadingActions.setLoading(false);
          const data = [...this.state.listData, ...this._listData];
          this.setState({ listData: data })
        })
        .catch(() => loadingActions.setLoading(false));
    }
  };

  public statusChangeHandler = (status: any) => {
    const listData = this.state.listData.map((item: any) => {
      if (item.id === this.state.activeItem.id) {
        item.status = status.name;
      }
      return item;
    });
    this.setState({
      listData: listData,
      activeItem: { ...this.state.activeItem, status: status },
      
    },() => this.triggerGetById(this.state.activeItem.id));

  };

  public onCreateClick = () => {
    const date = String(moment().toDate());
    const createData = new SampleFormData(
      false,
      uuidv4(),
      CONSTANTS.DefaultGuid,
      "",
      "",
      "",
      "",
      "",
      "",
      date,
      "",
      ""
    );
    History.push(CONSTANTS.SAMPLE_CREATE_URL_NEW, createData);
  };

  public viewAll() {
    History.push(CONSTANTS.SAMPLENEW_VIEW_ALL);
  }

  public cloneClick = () => {
    this.setState({
      showPopup: true,
    });
  };

  public onDelete = (deleteId: string) => {
    this.setState({
      filterOrder:'Desc'
    },()=>{
      this.actionCall();
    })

  };

  validate(): void {
    if (
      !this.state.nameError &&
      this.state.inputSampleName.trim() &&
      this.state.inputSampleName !== ""
    ) {
      this._isValid = true;
      this.setState({
        buttonDisabled: false,
      });
    } else {
      this._isValid = false;
      this.setState({
        buttonDisabled: true,
      });
    }
  }

  public setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      val.trim() &&
      !rgFile.test(val)
    ) {
      this.setState({ nameError: false, inputSampleName: val }, this.validate);
    } else {
      this.setState({ nameError: true, inputSampleName: val }, this.validate);
    }
  };

  public onActivate = () => {
    this.setState({
      showPopup: true,
    });
  };

  public onDeactivate = () => {
    this.setState({
      showPopup: false,
      inputSampleName: this.getInputNameForClone(this._activeItem.name),
      nameError: false,
      buttonDisabled: false,
    });
  };

  public showToastMessage = (isToast: boolean) => {
    this.setState(
      {
        toastMsg: isToast ? `${i18next.t("Saving")} ${this.state.activeItem?.name ?? ""} ${i18next.t("is inprogess...")}` : "",
        isToast: isToast ? true : false,
      })
  }

  public onCopy = (e: any, val: boolean) => {
    if (e !== null) {
      if (e.keyCode === 13) {
        this.setState({
          showPopup: false,
        });
        const sampleData = this.state.activeItem;
        if (this._isValid) {
          const tempName = this.state.inputSampleName
            .replace(/ +(?= )/g, "")
            .trim();
          this.setState(
            {
              inputSampleName: tempName,

              toastMsg: `${i18next.t("Copying")} ${sampleData?.name ?? ""} ${i18next.t("is inprogess...")}`,
              isToast: true,
            },
            () => {
              const sampleBody = new SampleFormData(
                false,
                uuidv4(),
                CONSTANTS.DefaultGuid,
                this.state.inputSampleName,
                sampleData.description,
                sampleData.product?.id,
                sampleData.source?.id,
                sampleData.orderId,
                sampleData.setId,
                sampleData.sampleDate,
                "",
                "",
                sampleData.measurement,
                sampleData.grade?.id,
                sampleData.testPlan?.id
              );
              sampleActions
                .copy(sampleBody)
                .then(() => {
                  this._message = [`${tempName} ${i18next.t("Created")}`];
                  triggerNotifications.success(this._message).then();
                  this.setState({
                    inputSampleName: "",
                    buttonDisabled: false,
                    isClonedCreated: true,
                    toastMsg: "",
                    isToast: false,
                  });
                  this._listData = [];
                  this.getAll();
                })
                .catch((error) => {
                  triggerNotifications.errors(error.message, error.data).then();
                  this.setState({
                    buttonDisabled: true,
                    isClonedCreated: false,
                    toastMsg: "",
                    isToast: false,
                  });
                });
            }
          );
        }
      }
    } else {
      this.setState({
        showPopup: false,
      });
      const sampleData = this.state.activeItem;
      if (this._isValid) {
        const tempName = this.state.inputSampleName
          .replace(/ +(?= )/g, "")
          .trim();
        this.setState(
          {
            inputSampleName: tempName,
            toastMsg: `${i18next.t("Copying")} ${sampleData?.name ?? ""} ${i18next.t("is inprogess...")}`,
            isToast: true,
          },
          () => {
            const sampleBody = new SampleFormData(
              false,
              uuidv4(),
              CONSTANTS.DefaultGuid,
              this.state.inputSampleName,
              sampleData.description,
              sampleData.product?.id,
              sampleData.source?.id,
              sampleData.orderId,
              sampleData.setId,
              sampleData.sampleDate,
              "",
              "",
              sampleData.measurement,
              sampleData.grade?.id,
              sampleData.testPlan?.id
            );
            sampleActions
              .copy(sampleBody)
              .then(() => {
                this._message = [`${tempName} ${i18next.t("Created")}`];
                triggerNotifications.success(this._message).then();
                this.setState({
                  inputSampleName: "",
                  buttonDisabled: false,
                  isClonedCreated: true,
                  toastMsg: "",
                  isToast: false,
                });
                this._listData = [];
                this.getAll();
              })
              .catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
                this.setState({
                  buttonDisabled: true,
                  isClonedCreated: false,
                  toastMsg: "",
                  isToast: false,
                });
              });
          }
        );
      }
    }
  };
  public onSave = (e: any, val: boolean) => {
    if (e !== null) {
      if (e.keyCode === 13) {
        this.setState({
          showPopup: false,
        });
        const sampleData = this.state.activeItem;
        if (this._isValid) {
          const tempName = this.state.inputSampleName
            .replace(/ +(?= )/g, "")
            .trim();
          this.setState(
            {
              inputSampleName: tempName,
            },
            () => {
              const sampleBody = new SampleFormData(
                false,
                uuidv4(),
                CONSTANTS.DefaultGuid,
                this.state.inputSampleName,
                sampleData.description,
                sampleData.product?.id,
                sampleData.source?.id,
                sampleData.orderId,
                sampleData.setId,
                sampleData.sampleDate,
                "",
                "",
                "",
                sampleData.grade?.id,
                sampleData.testPlan?.id
              );
              sampleActions
                .post(sampleBody)
                .then(() => {
                  triggerNotifications.success(this._message).then();
                  this.setState({
                    inputSampleName: "",
                    buttonDisabled: false,
                    isClonedCreated: true,
                  });
                  this._listData = [];
                  this.getAll();
                })
                .catch((error) => {
                  triggerNotifications.errors(error.message, error.data).then();
                  this.setState({
                    buttonDisabled: true,
                    isClonedCreated: false,
                  });
                });
            }
          );
        }
      }
    } else {
      this.setState({
        showPopup: false,
      });
      const sampleData = this.state.activeItem;
      if (this._isValid) {
        const tempName = this.state.inputSampleName
          .replace(/ +(?= )/g, "")
          .trim();
        this.setState(
          {
            inputSampleName: tempName,
          },
          () => {
            const sampleBody = new SampleFormData(
              false,
              uuidv4(),
              CONSTANTS.DefaultGuid,
              this.state.inputSampleName,
              sampleData.description,
              sampleData.product?.id,
              sampleData.source?.id,
              sampleData.orderId,
              sampleData.setId,
              sampleData.sampleDate,
              "",
              "",
              "",
              sampleData.grade?.id,
              sampleData.testPlan?.id
            );
            sampleActions
              .post(sampleBody)
              .then(() => {
                triggerNotifications.success(this._message).then();
                this.setState({
                  inputSampleName: "",
                  buttonDisabled: false,
                  isClonedCreated: true,
                });
                this._listData = [];
                this.getAll();
              })
              .catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
                this.setState({
                  buttonDisabled: true,
                  isClonedCreated: false,
                });
              });
          }
        );
      }
    }
  };

  dateRangeHandler = (val: any) => {
    this.setState(
      {
        selectedDateRange: val,
        selectedMeasurementStatus: this._defaultDrpOption,
        selectedGrade: this._defaultDrpOption,
        selectedProduct: this._defaultDrpOption,
        selectedSource: this._defaultDrpOption,
      },
      this.postAll
    );
    let fromDate: any = "",
      toDate: any = "";
    let selectedDate = val[0]?.value;
    toDate = moment().format(this._datetimeFormat);
    switch (selectedDate) {
      case 1:
        fromDate = moment().subtract(1, "d").format(this._datetimeFormat);
        break;
      case 2:
        fromDate = moment().subtract(7, "d").format(this._datetimeFormat);
        break;
      case 3:
        fromDate = moment().subtract(30, "d").format(this._datetimeFormat);
        break;
      case 4:
        fromDate = this.state.selectFromDate
          ? this.state.selectFromDate
          : moment().subtract(1, "d").format(this._datetimeFormat);
        toDate = this.state.selectToDate
          ? this.state.selectToDate
          : moment().format(this._datetimeFormat);
          document.removeEventListener("mousedown", this.handleClickOutside);
        break;
      default:
        fromDate = moment().subtract(1, "d").format(this._datetimeFormat);
        break;
    }

    if (moment(fromDate) >= moment(toDate)) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    } else {
      this.setState({
        selectFromDate: fromDate,
        selectToDate: toDate,
      });
    }
  };

  measurementStatusHandler = (values: any) => {
    if (values.length === 0) {
      values = this._defaultDrpOption;
    }
    if (
      values.find(
        (x: { value: string }) => x.value !== this._defaultDrpOption[0].value
      )
    ) {
      const inx = values.findIndex(
        (x: { value: string }) => x.value === this._defaultDrpOption[0].value
      );
      if (inx !== -1) {
        values.splice(inx, 1);
      }
    }
    this.setState(
      {
        selectedMeasurementStatus: values,
      },
      this.postAll
    );
  };

  private sourceChangeHandler = (val: any) => {
    if (val.length === 0) {
      val = this._defaultDrpOption;
    }
    if (
      val.find(
        (x: { value: string }) => x.value !== this._defaultDrpOption[0].value
      )
    ) {
      const inx = val.findIndex(
        (x: { value: string }) => x.value === this._defaultDrpOption[0].value
      );
      if (inx !== -1) {
        val.splice(inx, 1);
      }
    }
    this.setState(
      {
        selectedSource: val,
      },
      this.postAll
    );
  };

  private setTrendCustomFromDate = (val: any) => {
    if (moment(val).format(this._datetimeFormat) >= this.state.selectToDate) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    }
    this.setState(
      { selectFromDate: moment(val).format(this._datetimeFormat) },
      this.postAll
    );
    document.addEventListener("mousedown", this.handleClickOutside);
  };
  private setTrendCustomToDate = (val: any) => {
    if (this.state.selectFromDate >= moment(val).format(this._datetimeFormat)) {
      triggerNotifications.errors([CONSTANTS.FROM_GRATER_TO]).then();
    }
    this.setState(
      { selectToDate: moment(val).format(this._datetimeFormat) },
      this.postAll
    );
    document.addEventListener("mousedown", this.handleClickOutside);
  };
  private onDateFocus = () => {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  public showSelectFilterHandler = () => {
    this.setState({
      showFilter: !this.state.showFilter,
    },() => {
      if(this.state.showFilter){
        document.addEventListener("mousedown", this.handleClickOutside);
      } else{
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
    });
  };

  private productChangeHandler = (val: any) => {
    if (val.length === 0) {
      val = this._defaultDrpOption;
    }
    if (
      val.find(
        (x: { value: string }) => x.value !== this._defaultDrpOption[0].value
      )
    ) {
      const inx = val.findIndex(
        (x: { value: string }) => x.value === this._defaultDrpOption[0].value
      );
      if (inx !== -1) {
        val.splice(inx, 1);
      }
    }
    var arrayGrade: any[];
    arrayGrade = [];
    var arrayTestplan: any[];
    arrayTestplan = [];
    this.setState(
      {
        selectedProduct: val,
      },
      this.postAll
    );
  };

  private gradeChangeHandler = (val: any) => {
    if (val.length === 0) {
      val = this._defaultDrpOption;
    }
    if (
      val.find(
        (x: { value: string }) => x.value !== this._defaultDrpOption[0].value
      )
    ) {
      const inx = val.findIndex(
        (x: { value: string }) => x.value === this._defaultDrpOption[0].value
      );
      if (inx !== -1) {
        val.splice(inx, 1);
      }
    }
    var newArray: any[];
    newArray = [];
    var arrayTestplan: any[];
    arrayTestplan = [];

    let filteredProduct: any[] = [];
    val.map((item: any) => {
      const tempValue = this.state.productDataList.filter((product: any) => {
        return product.grade.id === item.value;
      });
      filteredProduct = [...filteredProduct, ...tempValue];
    });

    const filteredProductData: any[] = [];
    filteredProduct.forEach((product: IProductViewData) => {
      filteredProductData.push({
        label: product.name,
        value: product.id,
      });
    });
    this.setState(
      {
        selectedGrade: val,
        selectedProduct: this._defaultDrpOption,
        productList: filteredProductData,
      },
      this.postAll
    );
  };

  private reset = () => {
    this.setState(
      {
        selectedDateRange: [],
        selectFromDate: null,
        selectToDate: null,
        selectedGrade: this._defaultDrpOption,
        selectedMeasurementStatus: this._defaultDrpOption,
        selectedProduct: this._defaultDrpOption,
        selectedSource: this._defaultDrpOption,
        hasFiltersChanged: false,
        showFilter: false,
        isSorted: false,
        sortOrder: 0
      },
      () => {
        this.getAll();
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
    );
  };

  private clearAllFilters = () => {
    this.setState(
      {
        selectedDateRange: [],
        selectFromDate: null,
        selectToDate: null,
        selectedGrade: this._defaultDrpOption,
        selectedMeasurementStatus: this._defaultDrpOption,
        selectedProduct: this._defaultDrpOption,
        selectedSource: this._defaultDrpOption,
        hasFiltersChanged: false,
        showFilter: true,
      },
      () => {
        this.getAll();
        document.addEventListener("mousedown", this.handleClickOutside);
      }
    );
  };

  private getAll() {
    loadingActions.setLoading(true);
    this.setState({isLoading: true});
    if (this.state.isClonedCreated) {
      this._page = 1;
    }
    const pageSize = (this._pageToScroll + 1) * 30;

    const payload: any = {
      isAll: true,
      page: this.state.sortOrder === 0 ? 1 : null,
      pageSize: this.state.sortOrder === 0 ? pageSize : null,
      sort: "SampleDate",
      order: "Desc",
      OrderPrecedence: this.state.sortOrder,
      filter: this.state.searchValue ? `Name:${this.state.searchValue}` : "",
      startDateTime: this.state.selectFromDate
        ? moment(new Date(this.state.selectFromDate).toUTCString()).utc().format()
        : moment(new Date(Date.now() + -10 * 365 * 24 * 3600 * 1000).toUTCString()).utc().format(),
      endDateTime: this.state.selectToDate
        ? moment(new Date(this.state.selectToDate).toUTCString()).utc().format()
        : moment(new Date(Date.now() + 60 * 1000).toUTCString()).utc().format(),
      gradeIds:
        this.state.selectedGrade[0]?.value === this._defaultDrpOption[0]?.value
          ? null
          : this.state.selectedGrade?.map(({ value }: any) => value),
      productIds:
        this.state.selectedProduct[0]?.value ===
        this._defaultDrpOption[0]?.value
          ? null
          : this.state.selectedProduct?.map(({ value }: any) => value),
      measurementStatusIds:
        this.state.selectedMeasurementStatus[0]?.value ===
        this._defaultDrpOption[0]?.value
          ? null
          : this.state.selectedMeasurementStatus?.map(
              ({ value }: any) => value
            ),
      sourceIds:
        this.state.selectedSource[0]?.value === this._defaultDrpOption[0]?.value
          ? null
          : this.state.selectedSource?.map(({ value }: any) => value),
    };
    const requestId = uuidv4();
    sampleActions
      .postAll(payload, requestId)
      .then(() => {
        loadingActions.setLoading(false);
        this.setState({isLoading: false});
        this.setState(
          { listData: this._listData, isClonedCreated: false },
          () => {
            const firstItem = this.state.listData[0];
            if (this._reloadFirst) {
              if (this.state.listData.length > 0) {
                this.triggerGetById(firstItem.id);
              } else {
                const data: IActionHeaderEditData = {
                  moduleName: CONSTANTS.MODULE_SAMPLE,
                  editData: {},
                  deleteTitle: "",
                  deleteId: "",
                  isEnableViewAll: false,
                  exportId: "",
                  deleteRequestId: uuidv4(),
                  deleteMessage: "",
                  isEnableReport: true,
                };
                actionHeaderActions.edit(data).then();
              }
            } else {
              this.triggerGetById(this._id);
            }
          }
        );
      })
      .catch(() => {
        loadingActions.setLoading(false)
        this.setState({isLoading: false});
      });
  }

  postAll = () => {
    const pageSize = (this._pageToScroll + 1) * 30;
    const payload: any = {
      isAll: true,
      page: this.state.sortOrder === 0 ? 1 : null,
      pageSize: this.state.sortOrder === 0 ? pageSize : null,
      sort: "SampleDate",
      order: "Desc",
      OrderPrecedence: this.state.sortOrder,
      filter: this.state.searchValue ? `Name:${this.state.searchValue}` : "",
      startDateTime: this.state.selectFromDate
        ? moment(new Date(this.state.selectFromDate).toUTCString()).utc().format()
        : moment(new Date(Date.now() + -10 * 365 * 24 * 3600 * 1000).toUTCString()).utc().format(),
      endDateTime: this.state.selectToDate
        ? moment(new Date(this.state.selectToDate).toUTCString()).utc().format()
        : moment(new Date(Date.now() + 60 * 1000).toUTCString()).utc().format(),
      gradeIds:
        this.state.selectedGrade[0]?.value === this._defaultDrpOption[0]?.value
          ? null
          : this.state.selectedGrade?.map(({ value }) => value),
      productIds:
        this.state.selectedProduct[0]?.value ===
        this._defaultDrpOption[0]?.value
          ? null
          : this.state.selectedProduct?.map(({ value }) => value),
      measurementStatusIds:
        this.state.selectedMeasurementStatus[0]?.value ===
        this._defaultDrpOption[0]?.value
          ? null
          : this.state.selectedMeasurementStatus?.map(({ value }) => value),
      sourceIds:
        this.state.selectedSource[0]?.value === this._defaultDrpOption[0]?.value
          ? null
          : this.state.selectedSource?.map(({ value }) => value),
    };
    const requestId = uuidv4();
    sampleActions
      .postAll(payload, requestId)
      .then(() => {
        loadingActions.setLoading(false);
        this.setState(
          {
            listData: this._listData,
            isClonedCreated: false,
            hasFiltersChanged: true,
          },
          () => {
            const firstItem = this.state.listData[0];
            if (this._reloadFirst) {
              if (this.state.listData.length > 0) {
                this.triggerGetById(firstItem.id);
              } else {
                const data: IActionHeaderEditData = {
                  moduleName: CONSTANTS.MODULE_SAMPLE,
                  editData: {},
                  deleteTitle: "",
                  deleteId: "",
                  isEnableViewAll: false,
                  exportId: "",
                  deleteRequestId: uuidv4(),
                  deleteMessage: "",
                  isEnableReport: true,
                };
                actionHeaderActions.edit(data).then();
              }
            } else {
              this.triggerGetById(this._id);
            }
          }
        );
      })
      .catch(() => loadingActions.setLoading(false));
  };
  onScannerClick = (id: string): void => {
    const date = String(moment().toDate());
    const createData = new SampleFormData(
      false,
      uuidv4(),
      CONSTANTS.DefaultGuid,
      "",
      "",
      "",
      "",
      "",
      "",
      date,
      "",
      ""
    );
    if (id === "id") {
      History.push(CONSTANTS.SAMPLE_CREATE_URL, { formData: createData });
    } else {
      scannerActions.getById(id).then(() => {
        History.push(CONSTANTS.SAMPLE_CREATE_URL_NEW, {
          formData: createData,
          scannerData: this.state.scannerData,
        });
      });
    }
  };

  private handleClickOutside = (event: any) => {
    if (this.filterWrapperRef && !this.filterWrapperRef?.current?.contains(event.target)) {
      this.setState({showFilter: false},() => {
        document.removeEventListener("mousedown", this.handleClickOutside);
      })
    }
  }

  private sortArray = () => {
    const { sortOrder } = this.state;
    this.setState({
      sortOrder: sortOrder === 1 ? 2 : 1, 
      isSorted: true }, () => {
        this.getAll();
      });
  };


  render() {
    return (
      <Translation>
        {(t) => (
          <div className="layout-margin">
        {this.state.isLoading ? (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center', height: "90vh" }}><Spinner color="grey" sizeClass="medium" /></div>) : 

            (<>{(this.state.listData.length === 0 &&
              this.state.showFilter &&
              this.state.hasFiltersChanged) ||
            (this.state.listData.length === 0 && this.state.showFilter) ||
            (this.state.listData.length === 0 &&
              this.state.hasFiltersChanged) ||
            (this.state.listData.length !== 0 &&
              this.state.searchValue.length !== 0) ||
            this.state.listData.length !== 0 ||
            (this.state.listData.length === 0 &&
              this.state.searchValue.length !== 0) ? (
              <React.Fragment>
                {!this.state.collapseSidebar ? (
                  <div>
                    <Sidebar
                    authKey={CONSTANTS.AUTHKEY_SAMPLE_MODE}
                      isShowSelectFilter={true}
                      isShowSort={true}
                      reSet={this.reset}
                      showFilter={this.state.showFilter}
                      hasFiltersChanged={this.state.hasFiltersChanged}

                      onCollapseSidebar={this.onCollapseSidebar}
                      searchValue={this.state.searchValue}
                      onSearch={this.onSearch}
                      onCreateClick={this.onCreateClick}
                      viewAll={this.viewAll}
                      cloneClick={this.cloneClick}
                      onScannerClick={this.onScannerClick}
                      showSelectFilterHandler={this.showSelectFilterHandler}
                      setName={(val: string) => this.setName(val)}
                      inputName={this.state.inputSampleName}
                      isShowPopup={this.state.showPopup}
                      module={CONSTANTS.MODULE_SAMPLE}
                      nameError={this.state.nameError}
                      isButtonDisabled={this.state.buttonDisabled}
                      onActivate={this.onActivate}
                      onSave={this.onSave}
                      onCopy={this.onCopy}
                      onDeactivate={this.onDeactivate}
                      status={
                        this.state.activeItem &&
                        this.state.activeItem.status &&
                        (this.state.activeItem.status.name ===
                          CONSTANTS.APPROVED ||
                          this.state.activeItem.status.name ===
                            CONSTANTS.REJECTED ||
                          this.state.activeItem.status.name ===
                            CONSTANTS.MEASURED)
                          ? false
                          : true
                      }
                      sortArray={this.sortArray}
                      sortOrder={this.state.sortOrder}
                      isSorted={this.state.isSorted}
                    >
                      <SidebarList
                        onSelectLink={this.onSelectLink}
                        listData={this.state.listData}
                        activeId={this.state.activeId}
                        fetchMore={this.fetchMore}
                        hasMore={this._hasMore}
                        module={CONSTANTS.MODULE_SAMPLE}
                      ></SidebarList>
                    </Sidebar>
                  </div>
                ) : (
                  <SidebarCollapse
                  authKey={CONSTANTS.AUTHKEY_SAMPLE_MODE}
                    onCollapseSidebar={this.onCollapseSidebar}
                    onCreateClick={this.onCreateClick}
                    viewAll={this.viewAll}
                    cloneClick={this.cloneClick}
                    onActivate={this.onActivate}
                    onScannerClick={this.onScannerClick}

                    setName={(val: string) => this.setName(val)}
                    inputName={this.state.inputSampleName}
                    isShowPopup={this.state.showPopup}
                    module={CONSTANTS.MODULE_SAMPLE}
                    nameError={this.state.nameError}
                    isButtonDisabled={this.state.buttonDisabled}
                    onSave={this.onSave}
                    onDeactivate={this.onDeactivate}
                    showCloneIcon={true}
                  ></SidebarCollapse>
                )}

                {
                  this.state.showFilter && (
                    <div ref={this.filterWrapperRef}><SampleFilter
                      selectFromDate={this.state.selectFromDate}
                      selectToDate={this.state.selectToDate}
                      selectedDateRange={this.state.selectedDateRange}
                      gradeList={this.state.gradeList}
                      selectedGrade={this.state.selectedGrade}
                      measurementStatusList={this.state.measurementStatusList}
                      selectedMeasurementStatus={
                        this.state.selectedMeasurementStatus
                      }
                      productList={this.state.productList}
                      selectedProduct={this.state.selectedProduct}
                      sourceList={this.state.sourceList}
                      selectedSource={this.state.selectedSource}
                      dateRangeHandler={this.dateRangeHandler}
                      setTrendCustomFromDate={this.setTrendCustomFromDate}
                      setTrendCustomToDate={this.setTrendCustomToDate}
                      measurementStatusHandler={this.measurementStatusHandler}
                      gradeChangeHandler={this.gradeChangeHandler}
                      productChangeHandler={this.productChangeHandler}
                      sourceChangeHandler={this.sourceChangeHandler}
                      clearAllFilters={this.clearAllFilters}
                      reSet={this.reset}
                      hasFiltersChanged={this.state.hasFiltersChanged}
                      showSelectFilterHandler={this.showSelectFilterHandler}
                      onDateFocus={this.onDateFocus}
                    /></div>
                  )
                }
                <Landing
                  sampleData={this.state.activeItem}
                  activeItem={this.state.activeItem}
                  sidebarCollapsed={this.state.collapseSidebar}
                  statusChangeHandler={this.statusChangeHandler}
                  onDelete={this.onDelete}
                  childRef={this._childRef}
                  toastMsg={this.state.toastMsg}
                  isToast={this.state.isToast}
                  showToastMessage={this.showToastMessage}
                ></Landing>
              </React.Fragment>
            ) : (
              <NoDataOnboarding
                moduleName={CONSTANTS.MODULE_SAMPLE}
                onCreateClick={this.onCreateClick}
                onScannerClick={this.onScannerClick}
                authKey={CONSTANTS.AUTHKEY_SAMPLE_MODE}
              />
            )}</>)}
          </div>
        )}
      </Translation>
    );
  }
}
